export const mockTenantBreakdownData = {
    serviceRequests: [
        {
            type: "General Maintenance",
            serviceRequests: [
                {
                    tenantName: "Perlogic",
                    value: 5,
                },
                {
                    tenantName: "Medicare",
                    value: 2,
                },
                {
                    tenantName: "Affinance",
                    value: 1,
                },
                {
                    tenantName: "Ruledge",
                    value: 5,
                },
                {
                    tenantName: "TechFever",
                    value: 2,
                },
                {
                    tenantName: "Delta",
                    value: 0,
                },
            ],
        },
        {
            type: "Plumbing",
            serviceRequests: [
                {
                    tenantName: "Perlogic",
                    value: 7,
                },
                {
                    tenantName: "Medicare",
                    value: 0,
                },
                {
                    tenantName: "Affinance",
                    value: 2,
                },
                {
                    tenantName: "Ruledge",
                    value: 7,
                },
                {
                    tenantName: "TechFever",
                    value: 8,
                },
                {
                    tenantName: "Delta",
                    value: 9,
                },
            ],
        },
        {
            type: "Lighting",
            serviceRequests: [
                {
                    tenantName: "Perlogic",
                    value: 4,
                },
                {
                    tenantName: "Medicare",
                    value: 8,
                },
                {
                    tenantName: "Affinance",
                    value: 2,
                },
                {
                    tenantName: "Ruledge",
                    value: 1,
                },
                {
                    tenantName: "TechFever",
                    value: 0,
                },
                {
                    tenantName: "Delta",
                    value: 6,
                },
            ],
        },
        {
            type: "Janitorial",
            serviceRequests: [
                {
                    tenantName: "Perlogic",
                    value: 8,
                },
                {
                    tenantName: "Medicare",
                    value: 9,
                },
                {
                    tenantName: "Affinance",
                    value: 2,
                },
                {
                    tenantName: "Ruledge",
                    value: 4,
                },
                {
                    tenantName: "TechFever",
                    value: 2,
                },
                {
                    tenantName: "Delta",
                    value: 3,
                },
            ],
        },
        {
            type: "HVAC",
            serviceRequests: [
                {
                    tenantName: "Perlogic",
                    value: 5,
                },
                {
                    tenantName: "Medicare",
                    value: 5,
                },
                {
                    tenantName: "Affinance",
                    value: 2,
                },
                {
                    tenantName: "Ruledge",
                    value: 7,
                },
                {
                    tenantName: "TechFever",
                    value: 4,
                },
                {
                    tenantName: "Delta",
                    value: 1,
                },
            ],
        },
        {
            type: "Access",
            serviceRequests: [
                {
                    tenantName: "Perlogic",
                    value: 3,
                },
                {
                    tenantName: "Medicare",
                    value: 7,
                },
                {
                    tenantName: "Affinance",
                    value: 9,
                },
                {
                    tenantName: "Ruledge",
                    value: 1,
                },
                {
                    tenantName: "TechFever",
                    value: 3,
                },
                {
                    tenantName: "Delta",
                    value: 11,
                },
            ],
        },
    ],
};
